import { UniDriver } from '@wix/unidriver-core';

export const hasDataAttr = async (
  base: UniDriver,
  field: string,
  expectedValue: any,
): Promise<boolean> => {
  const fieldValue = await base.attr(`data-${field}`);
  return fieldValue === expectedValue;
};

export const hasMobile = async (base: UniDriver): Promise<boolean> => {
  return hasDataAttr(base, 'mobile', 'true');
};

export const dataHook = (value: string) => `[data-hook="${value}"]`;

export const dataHookContains = (value: string) => `[data-hook~="${value}"]`;
